import { render, staticRenderFns } from "./AreaChartTy.vue?vue&type=template&id=18834924&scoped=true&"
import script from "./AreaChartTy.vue?vue&type=script&lang=js&"
export * from "./AreaChartTy.vue?vue&type=script&lang=js&"
import style0 from "./AreaChartTy.vue?vue&type=style&index=0&id=18834924&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18834924",
  null
  
)

export default component.exports